import React, { useState , useEffect } from 'react';
import { Input, Label, UncontrolledTooltip } from 'reactstrap';
import wiki from '../../assets/images/wiki.svg';
import web from '../../assets/images/Icon-2.svg';
import map from '../../assets/images/Icon-3.svg';
import weather from '../../assets/images/Icon-4.svg';
import youtube from '../../assets/images/Icon-5.svg';
import { useDispatch, useSelector } from 'react-redux';
import { TOGGLE_TOOL_STATUS } from '../../slices/thunks';



const Tool_List_View = ({ tools , bot_id})=>{
     
    const [active, set_active] = useState(tools.is_active);
    const dispatch = useDispatch();

    const icons = {
        "Google Map":map,
        "Open Weather Map":weather,
        "Wikipedia Retriever":wiki,
        "Youtube Search":youtube
    }

  useEffect(() => {
    set_active(tools.is_active);
    // console.log("Re render");

   
    
  }, [tools.is_active]); // ✅ only update if is_active actually changes

  const handleChange = (e) => {
    const newValue = e.target.checked;
    // e.stopPropagation();
    set_active(newValue);

    dispatch(
      TOGGLE_TOOL_STATUS({
        tool_id: tools.Id,
        bot_id: bot_id,
        tool_status: newValue ? 'activated' : 'deactivated',
      })
    );
  };


 

      return  <li>
                <div className='tool_item'>
                    <div className="icon_head_sub">
                        <img src={icons[tools.ToolName]} alt="icon" width="20" height="20" id="tool_discription"/>
                        <div>
                            <p className='no-margin'>{tools.ToolName}</p>
                            <p className='no-margin tools_description'><small>{tools.Description}</small></p>
                            <UncontrolledTooltip
                                placement="left"
                                target={`tool_discription`}
                                className="leftmore"
                            >
                                {tools.Description}
                            </UncontrolledTooltip>
                        </div>
                    </div>
                    <div className="flex-shrink-0">
                        <div className="form-check form-switch form-switch-right form-switch-md">                            
                            <Input onClick={(e)=>{
                                e.stopPropagation();
                            }} onChange={handleChange} checked={active}  className="form-check-input code-switcher" type="checkbox" id={`switch-${tools.Id}`} />
                        </div>
                    </div>
                </div>
            </li>
}

const Chat_Tool = ({ isActiveWeb , handleClick_button }) => {
      const { Tool_List, Bot_Details } = useSelector((state) => state.BotDetails);
  return (
    <>
      <div className='tool_wraper_chat'>
        <strong>Tools</strong>
        <ul>
            {/* <li>
                <div className='tool_item'>
                    <div className="icon_head_sub">
                        <img src={web} alt="icon" width="20" height="20" id="tool_discription_Web"/>
                        <div>
                            <p className='no-margin'>Web</p>
                            <p className='no-margin'><small> Search on internet</small></p>
                            <UncontrolledTooltip
                                placement="left"
                                target={`tool_discription_Web`}
                                className="leftmore"
                            >
                                Search on internet
                            </UncontrolledTooltip>
                        </div>
                    </div>
                    <div className="flex-shrink-0">
                        <div className="form-check form-switch form-switch-right form-switch-md">                            
                            <Input checked={isActiveWeb} onChange={handleClick_button} onClick={(e)=>{
                                e.stopPropagation();
                            }} className="form-check-input code-switcher" type="checkbox" />
                        </div>
                    </div>
                </div>
            </li> */}


            { Bot_Details.Type != "DBLink" &&  Tool_List?.tool_master_value?.map((item, index) => (
            <Tool_List_View tools={item} key={index} bot_id={Bot_Details.Bot_ID} />
          ))}
          
            {/* <li>
                <div className='tool_item'>
                    <div className="icon_head_sub">
                        <img src={map} alt="icon" width="20" height="20"/>
                        <div>
                            <p className='no-margin'>Google map</p>
                            <p className='no-margin'><small>A tool shows map</small></p>
                        </div>
                    </div>
                    <div className="flex-shrink-0">
                        <div className="form-check form-switch form-switch-right form-switch-md">                            
                            <Input className="form-check-input code-switcher" type="checkbox" />
                        </div>
                    </div>
                </div>
            </li>
            <li>
                <div className='tool_item'>
                    <div className="icon_head_sub">
                        <img src={weather} alt="icon" width="20" height="20"/>
                        <div>
                            <p className='no-margin'>Weather</p>
                            <p className='no-margin'><small>Search real time weather</small></p>
                        </div>
                    </div>
                    <div className="flex-shrink-0">
                        <div className="form-check form-switch form-switch-right form-switch-md">                            
                            <Input className="form-check-input code-switcher" type="checkbox" />
                        </div>
                    </div>
                </div>
            </li>
            <li>
                <div className='tool_item'>
                    <div className="icon_head_sub">
                        <img src={youtube} alt="icon" width="20" height="20"/>
                        <div>
                            <p className='no-margin'>YouTube</p>
                            <p className='no-margin'><small>Fetch YouTube videos</small></p>
                        </div>
                    </div>
                    <div className="flex-shrink-0">
                        <div className="form-check form-switch form-switch-right form-switch-md">                            
                            <Input className="form-check-input code-switcher" type="checkbox" />
                        </div>
                    </div>
                </div>
            </li>
            <li>
                <div className='tool_item'>
                    <div className="icon_head_sub">
                        <img src={wiki} alt="icon" width="20" height="20"/>
                        <div>
                            <p className='no-margin'>Wikipedia</p>
                            <p className='no-margin'><small>Search on wikipedia</small></p>
                        </div>
                    </div>
                    <div className="flex-shrink-0">
                        <div className="form-check form-switch form-switch-right form-switch-md">                            
                            <Input className="form-check-input code-switcher" type="checkbox" />
                        </div>
                    </div>
                </div>
            </li> */}
        </ul>
      </div>
    </>
  )
}

export default Chat_Tool